import { useSuspenseQuery } from "@tanstack/react-query"
import {
  createQueryKey,
  FUNDRAISING_ADVISORY_BASE_KEY,
} from "@/api/query-keys.ts"
import {
  GetCompetitorsFundingAnalysisOptionsRequest,
  GetCompetitorsFundingAnalysisResponse,
} from "@/feature/fundraising-advisory/competitors-funding-analysis/api/types.ts"
import { axiosInstance } from "@/api/axios.ts"

const createCfaQueryKey = (
  request: GetCompetitorsFundingAnalysisOptionsRequest
) =>
  createQueryKey({
    baseKey: FUNDRAISING_ADVISORY_BASE_KEY,
    keys: [
      `cfa`,
      `perPage_${request.perPage}`,
      `page_${request.page}`,
      request.orderBy,
    ],
  })
export const getCompetitorsFundingAnalysis = async (
  request: GetCompetitorsFundingAnalysisOptionsRequest
): Promise<GetCompetitorsFundingAnalysisResponse> =>
  (
    await axiosInstance.get<GetCompetitorsFundingAnalysisResponse>(
      `/fundraising/competitors-funding-analysis`,
      {
        params: request,
      }
    )
  ).data

export const getCompetitorsFundingAnalysisQuery = (
  request: GetCompetitorsFundingAnalysisOptionsRequest
) => ({
  queryKey: createCfaQueryKey(request),
  queryFn: () => getCompetitorsFundingAnalysis(request),
})

export const useCompetitorsFundingAnalysis = (
  request: GetCompetitorsFundingAnalysisOptionsRequest
) => useSuspenseQuery(getCompetitorsFundingAnalysisQuery(request))
